import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [state, setState] = useState({ user: null });
    const [loading, setLoading] = useState(true);
    const refresh = useCallback(async () => {
        try {
            const me = await api.get("/api/me");
            setState(me);
        }
        catch {
            setState({ user: null });
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => { refresh(); }, [refresh]);
    const login = async (email, password) => {
        await api.post("/api/auth/login", { email, password });
        await refresh();
    };
    const logout = async () => {
        await api.post("/api/auth/logout").catch(() => { });
        setState({ user: null });
    };
    return (_jsx(Ctx.Provider, { value: {
            user: state.user,
            loading,
            classes: state.classes,
            student: state.student,
            children: state.children,
            login, logout, refresh,
        }, children: children }));
}
export function useAuth() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("useAuth outside AuthProvider");
    return v;
}
